module.exports = __webpack_public_path__ + "img/horangit.61f8186a.png";